import { render } from "./SidebarIcon.vue?vue&type=template&id=89ff15f4"
import script from "./SidebarIcon.vue?vue&type=script&lang=js"
export * from "./SidebarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__